export default __webpack_public_path__ + "static/media/footer.6461ee78.png";